module.exports = __webpack_public_path__ + "music-notewp12b8e15b1f882184a62f9ad823a5705b.png";